import React from 'react';

const AppStoreSVG = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='26.521' height='31' viewBox='0 0 26.521 31'>
    <g id='Layer_2' data-name='Layer 2' transform='translate(0.013)'>
      <g id='Layer_1' data-name='Layer 1' transform='translate(-0.013 0)'>
        <path
          id='Path_6643'
          data-name='Path 6643'
          d='M7.945,2.084a8.168,8.168,0,0,1,3.179.48c.591.185,1.146.407,1.737.554A5.1,5.1,0,0,0,16,2.9a15.6,15.6,0,0,1,2.218-.739,7.392,7.392,0,0,1,6.246,1.4,9.277,9.277,0,0,1,1.368,1.331c0,.185,0,.222,0,.37a6.32,6.32,0,0,0-3.622,5.1,6.764,6.764,0,0,0,1.885,5.47,6.985,6.985,0,0,0,2.218,1.515c.259,0,.259,0,0,.37a22.916,22.916,0,0,1-3.7,5.988,7.392,7.392,0,0,1-1.848,1.552,3.7,3.7,0,0,1-3.474,0l-1.441-.628a6.949,6.949,0,0,0-4.8.222l-1.22.517A4.066,4.066,0,0,1,5.949,24.7,10.423,10.423,0,0,1,4.027,22.6,20.624,20.624,0,0,1,.959,16.868a17.926,17.926,0,0,1-.924-4.657A10.792,10.792,0,0,1,.774,7.148,8.39,8.39,0,0,1,6.392,2.084a4.583,4.583,0,0,1,1.552,0Z'
          transform='translate(0.013 5.308)'
          fill='#fdfdfd'
          fillRule='evenodd'
        />
        <path
          id='Path_6644'
          data-name='Path 6644'
          d='M9.893.7a6.727,6.727,0,0,1-1.22,3.881A6.505,6.505,0,0,1,5.162,7.392a4.4,4.4,0,0,1-1.368,0H3.5A5.507,5.507,0,0,1,4.09,4.324,7.392,7.392,0,0,1,8.452.628,5.877,5.877,0,0,1,9.671,0l.222.222a2.07,2.07,0,0,1,0,.48Z'
          transform='translate(9.411 0)'
          fill='#fdfdfd'
          fillRule='evenodd'
        />
      </g>
    </g>
  </svg>
);
export default AppStoreSVG;
